<template>
    <div class="templete_box">
        <div class="crumbsNav no_print clearfix">
            <div :class="['navSon',tab==1?'navSonChecked':'']" @click="changeTab(1)" v-if="categoryBoardType">
                板材合同管理 <span v-if="purchase">({{purchase}})</span>
            </div>
            <div :class="['navSon',tab==2?'navSonChecked':'']" @click="changeTab(2)" v-if="categoryRawType">
                原木合同管理
            </div>
            <div v-if="module.indexOf(',cloud-purchase-order,')!=-1" :class="['navSon',tab==3?'navSonChecked':'']" @click="changeTab(3)">
                云链采购管理
            </div>
            <div v-if="module.indexOf(',finance-order,')!=-1" :class="['navSon',tab==4?'navSonChecked':'']" @click="changeTab(4)">
                融资合同管理 <span v-if="finance">({{finance}})</span>
            </div>
            <div v-if="module.indexOf(',purchase-sales-list,')!=-1" :class="['navSon',tab==5?'navSonChecked':'']" @click="changeTab(5)">
                板材调货管理
            </div>
        </div>
        <purchaseBoardList @contract-num='contractNum' v-if="tab == 1"></purchaseBoardList>
        <purchaseWoodList v-if="tab == 2"></purchaseWoodList>
        <purchaseCloudList v-if="tab == 3"></purchaseCloudList>
        <purchaseFinanceList @contract-num='contractNum' v-if="tab == 4"></purchaseFinanceList>
        <purchaseCondimentsList v-if="tab == 5"></purchaseCondimentsList>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                module:localStorage.dw_erp_power_code,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                tab : 1,
                purchase:'',
                finance:''
            }
        },
        created(){
        },
        methods:{
            changeTab(tab){
                //this.tab=tab;
                this.$set(this,"tab",tab);
            },
            contractNum(data){
                this.purchase = data.purchase;
                this.finance = data.finance;
            }
        }
    }
</script>
<style scoped>
    .navSon{padding:0 0px;font-size: 14px;line-height: 30px;float: left;margin-right:80px;}
    .navSonChecked{color: #B21111;}
</style>